// This data was generated from the dataset linked below with data aggregation done in a Jupyter notebook.
// Dataset: Link

const data = [
  {
    semester: 'All semesters',
    bin: 25,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 50,
    'Number of emails sent': 12,
  },
  {
    semester: 'All semesters',
    bin: 75,
    'Number of emails sent': 18,
  },
  {
    semester: 'All semesters',
    bin: 100,
    'Number of emails sent': 20,
  },
  {
    semester: 'All semesters',
    bin: 125,
    'Number of emails sent': 6,
  },
  {
    semester: 'All semesters',
    bin: 150,
    'Number of emails sent': 6,
  },
  {
    semester: 'All semesters',
    bin: 175,
    'Number of emails sent': 12,
  },
  {
    semester: 'All semesters',
    bin: 200,
    'Number of emails sent': 2,
  },
  {
    semester: 'All semesters',
    bin: 225,
    'Number of emails sent': 4,
  },
  {
    semester: 'All semesters',
    bin: 250,
    'Number of emails sent': 2,
  },
  {
    semester: 'All semesters',
    bin: 275,
    'Number of emails sent': 2,
  },
  {
    semester: 'All semesters',
    bin: 300,
    'Number of emails sent': 2,
  },
  {
    semester: 'All semesters',
    bin: 325,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 350,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 375,
    'Number of emails sent': 1,
  },
  {
    semester: 'All semesters',
    bin: 400,
    'Number of emails sent': 2,
  },
  {
    semester: 'All semesters',
    bin: 425,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 450,
    'Number of emails sent': 2,
  },
  {
    semester: 'All semesters',
    bin: 475,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 500,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 525,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 550,
    'Number of emails sent': 1,
  },
  {
    semester: 'All semesters',
    bin: 575,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 600,
    'Number of emails sent': 1,
  },
  {
    semester: 'All semesters',
    bin: 625,
    'Number of emails sent': 1,
  },
  {
    semester: 'All semesters',
    bin: 650,
    'Number of emails sent': 1,
  },
  {
    semester: 'All semesters',
    bin: 675,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 700,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 725,
    'Number of emails sent': 1,
  },
  {
    semester: 'All semesters',
    bin: 750,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 775,
    'Number of emails sent': 1,
  },
  {
    semester: 'All semesters',
    bin: 800,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 825,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 850,
    'Number of emails sent': 0,
  },
  {
    semester: 'All semesters',
    bin: 875,
    'Number of emails sent': 1,
  },
  {
    semester: 'All semesters',
    bin: 900,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 25,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 50,
    'Number of emails sent': 5,
  },
  {
    semester: 'Fall 2021',
    bin: 75,
    'Number of emails sent': 6,
  },
  {
    semester: 'Fall 2021',
    bin: 100,
    'Number of emails sent': 7,
  },
  {
    semester: 'Fall 2021',
    bin: 125,
    'Number of emails sent': 2,
  },
  {
    semester: 'Fall 2021',
    bin: 150,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 175,
    'Number of emails sent': 2,
  },
  {
    semester: 'Fall 2021',
    bin: 200,
    'Number of emails sent': 2,
  },
  {
    semester: 'Fall 2021',
    bin: 225,
    'Number of emails sent': 2,
  },
  {
    semester: 'Fall 2021',
    bin: 250,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 275,
    'Number of emails sent': 1,
  },
  {
    semester: 'Fall 2021',
    bin: 300,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 325,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 350,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 375,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 400,
    'Number of emails sent': 1,
  },
  {
    semester: 'Fall 2021',
    bin: 425,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 450,
    'Number of emails sent': 1,
  },
  {
    semester: 'Fall 2021',
    bin: 475,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 500,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 525,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 550,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 575,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 600,
    'Number of emails sent': 1,
  },
  {
    semester: 'Fall 2021',
    bin: 625,
    'Number of emails sent': 1,
  },
  {
    semester: 'Fall 2021',
    bin: 650,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 675,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 700,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 725,
    'Number of emails sent': 1,
  },
  {
    semester: 'Fall 2021',
    bin: 750,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 775,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 800,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 825,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 850,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 875,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2021',
    bin: 900,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 25,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 50,
    'Number of emails sent': 2,
  },
  {
    semester: 'Spring 2022',
    bin: 75,
    'Number of emails sent': 4,
  },
  {
    semester: 'Spring 2022',
    bin: 100,
    'Number of emails sent': 4,
  },
  {
    semester: 'Spring 2022',
    bin: 125,
    'Number of emails sent': 1,
  },
  {
    semester: 'Spring 2022',
    bin: 150,
    'Number of emails sent': 2,
  },
  {
    semester: 'Spring 2022',
    bin: 175,
    'Number of emails sent': 2,
  },
  {
    semester: 'Spring 2022',
    bin: 200,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 225,
    'Number of emails sent': 1,
  },
  {
    semester: 'Spring 2022',
    bin: 250,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 275,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 300,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 325,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 350,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 375,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 400,
    'Number of emails sent': 1,
  },
  {
    semester: 'Spring 2022',
    bin: 425,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 450,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 475,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 500,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 525,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 550,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 575,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 600,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 625,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 650,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 675,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 700,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 725,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 750,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 775,
    'Number of emails sent': 1,
  },
  {
    semester: 'Spring 2022',
    bin: 800,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 825,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 850,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 875,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2022',
    bin: 900,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 25,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 50,
    'Number of emails sent': 4,
  },
  {
    semester: 'Fall 2022',
    bin: 75,
    'Number of emails sent': 3,
  },
  {
    semester: 'Fall 2022',
    bin: 100,
    'Number of emails sent': 4,
  },
  {
    semester: 'Fall 2022',
    bin: 125,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 150,
    'Number of emails sent': 1,
  },
  {
    semester: 'Fall 2022',
    bin: 175,
    'Number of emails sent': 5,
  },
  {
    semester: 'Fall 2022',
    bin: 200,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 225,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 250,
    'Number of emails sent': 2,
  },
  {
    semester: 'Fall 2022',
    bin: 275,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 300,
    'Number of emails sent': 2,
  },
  {
    semester: 'Fall 2022',
    bin: 325,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 350,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 375,
    'Number of emails sent': 1,
  },
  {
    semester: 'Fall 2022',
    bin: 400,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 425,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 450,
    'Number of emails sent': 1,
  },
  {
    semester: 'Fall 2022',
    bin: 475,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 500,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 525,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 550,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 575,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 600,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 625,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 650,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 675,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 700,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 725,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 750,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 775,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 800,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 825,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 850,
    'Number of emails sent': 0,
  },
  {
    semester: 'Fall 2022',
    bin: 875,
    'Number of emails sent': 1,
  },
  {
    semester: 'Fall 2022',
    bin: 900,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 25,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 50,
    'Number of emails sent': 1,
  },
  {
    semester: 'Spring 2023',
    bin: 75,
    'Number of emails sent': 5,
  },
  {
    semester: 'Spring 2023',
    bin: 100,
    'Number of emails sent': 5,
  },
  {
    semester: 'Spring 2023',
    bin: 125,
    'Number of emails sent': 3,
  },
  {
    semester: 'Spring 2023',
    bin: 150,
    'Number of emails sent': 3,
  },
  {
    semester: 'Spring 2023',
    bin: 175,
    'Number of emails sent': 3,
  },
  {
    semester: 'Spring 2023',
    bin: 200,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 225,
    'Number of emails sent': 1,
  },
  {
    semester: 'Spring 2023',
    bin: 250,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 275,
    'Number of emails sent': 1,
  },
  {
    semester: 'Spring 2023',
    bin: 300,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 325,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 350,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 375,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 400,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 425,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 450,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 475,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 500,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 525,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 550,
    'Number of emails sent': 1,
  },
  {
    semester: 'Spring 2023',
    bin: 575,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 600,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 625,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 650,
    'Number of emails sent': 1,
  },
  {
    semester: 'Spring 2023',
    bin: 675,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 700,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 725,
    'Number of emails sent': 0,
  },
  {
    semester: 'Spring 2023',
    bin: 750,
    'Number of emails sent': 0,
  },
];

export default data;
